/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { FormattedDate } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import { HomepageCalendarDay, HomepageCalendarItem, HomepageCalendar } from './homepage-calendar';

import { getFullDateString } from '../utilities/dates';
import DateRange from './date-range';
import EVENT_TYPE_ICONS from '../constants/event-type-icons';

function getEvents(events, currentDay, localizations) {
  const currentDateString = getFullDateString(currentDay);

  return events.reduce((calendarItems, event) => {
    if (event.instanceDates && event.instanceDates.includes(currentDateString)) {
      const { iconAssistiveText, iconAssistiveTextKey, ...eventIcon } =
        EVENT_TYPE_ICONS[event.type] || EVENT_TYPE_ICONS.CUSTOM;

      eventIcon.iconAssistiveText = localizations[iconAssistiveTextKey] || iconAssistiveText;

      calendarItems.push(<HomepageCalendarItem {...eventIcon} key={event.id} text={event.title} />);
    }

    return calendarItems;
  }, []);
}

function Calendar(props) {
  return (
    <div className="slds-p-top--large">
      <HomepageCalendar
        calendarLabel={props.localizations['homepage.calendar.heading']}
        dateRange={<DateRange startDate={props.startDate} endDate={props.endDate} />}
        onExpandClick={props.onExpandClick}
      >
        {props.dates.map((currentDay) => (
          <HomepageCalendarDay
            current={currentDay.getTime() === props.selectedDate.getTime()}
            date={currentDay.getDate()}
            dayText={<FormattedDate weekday="short" value={currentDay} />}
            key={currentDay.getDate()}
            onEllipsisClick={props.onExpandClick}
          >
            {getEvents(props.events, currentDay, props.localizations)}
          </HomepageCalendarDay>
        ))}
      </HomepageCalendar>
    </div>
  );
}

Calendar.displayName = 'Calendar';

Calendar.propTypes = {
  dates: PropTypes.array,
  endDate: PropTypes.object,
  events: PropTypes.array,
  localizations: PropTypes.object,
  onExpandClick: PropTypes.func,
  selectedDate: PropTypes.object,
  startDate: PropTypes.object,
};

export default Calendar;
